export const NAV_BAR_DESKTOP_TEST_ID = {
  container: 'primary-nav-container',
  phoneNumberLink: 'phone-number-link',
  phoneNumber: 'phone-number',
};
